import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { eventBus } from '@atc/cai-event-bus';

import { WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST } from 'wallet-manager';

const AUTH_SIGNIN_COMPLETE = 'auth.signin';

export default function useWalletInitialization({ paymentsDuck, onComplete = () => {} }) {
    const dispatch = useDispatch();

    function handleCompareLoggedInWalletData() {
        eventBus.emit(WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST);
    }

    const handleWalletInitialization = ({ paymentInfo } = {}) => {
        onComplete(paymentInfo);
        dispatch(paymentsDuck.creators.ensurePaymentsInfo());
    };

    useEffect(() => {
        eventBus.on(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);

        return () => {
            eventBus.off(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        eventBus.on(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);

        return () => {
            eventBus.off(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);
        };
    }, []);

    return null;
}
